<template>
  <div>
    <div class="news-big-structure-wrapper" v-if="bigTemplate">
      <div class="top">
        <b-row>
          <b-col sm="6">
            <slot name="highlighted"></slot>
          </b-col>

          <b-col sm="6">
            <slot name="list"></slot>
          </b-col>
        </b-row>
      </div>

      <div class="bottom">
        <b-row>
          <slot name="rest"></slot>
        </b-row>
      </div>
    </div>

    <div class="news-structure-wrapper" v-else>
      <b-row>
        <slot name="releasesSimpleList"></slot>
      </b-row>
    </div>

  </div>
</template>

<script>
  // Mixins
  import { mixinWindowResizeListener } from '@/mixins/window-resize-listener';

  export default {
    name: 'NewsStructure',

    mixins: [mixinWindowResizeListener],

    data: function () {
      return {
        bigTemplate: false,
      }
    },

    methods: {
      resize(windowsWidth) {
        if (windowsWidth >= 980) {
          this.bigTemplate = true;
          return;
        }

        this.bigTemplate = false;
      }
    },

    watch: {
      'mixinWindowResizeListenerData.width': function (newVal) {
        this.resize(newVal);
      },
    },
  }
</script>

<style scoped lang="scss">
.news-big-structure-wrapper {
  width: 100%;

  .top {
    width: 100%;
    .column {
      width: 100%;
    }
  }

  /*deep*/
  .bottom {
    width: 100%;
  }
}
</style>
